import { createEvent, restore, sample } from 'effector'
import { getServiceList } from '../list/model'
import { Service } from '../list/types'
import { fx } from '../../../../libs'

export const serviceLangListMounted = createEvent()

export const syncOneLanguageMounted = createEvent<{
  service: string
  language: string
}>()

export const $serviceLangList = restore<Service[]>(
  getServiceList.doneData.map((a) => a.body.items),
  [],
)

sample({
  // @ts-ignore
  clock: serviceLangListMounted,
  fn: () => {
    return {
      url: `/translation/service/language/list`,
    }
  },
  target: getServiceList,
})

export const syncOneLanguageStatus = fx<
  { service: string; language: string },
  { status: string }
>({
  method: 'POST',
  url: `/translation/service/language/sync_one_language`,
})

sample({
  clock: syncOneLanguageMounted,
  fn: (data) => {
    return {
      url: '/translation/service/language/sync_one_language',
      body: {
        ...data,
      },
    }
  },
  target: syncOneLanguageStatus,
})
